function init() {
	// Find all elements with the data-toggle-view attribute
	document
	.querySelectorAll( '[data-toggle-view]' )
	.forEach( function( ctrl ) {
		ctrl.addEventListener( 'click', function() {
			// Read the selectors from data-attributes
			var parentSelector = ctrl.dataset.parentSelector;
			var expandedSelector = ctrl.dataset.expandedSelector;
			var collapsedSelector = ctrl.dataset.collapsedSelector;

			// Find the container
			var container = ctrl.closest( parentSelector );
			if ( !container ) {
				return;
			}

			if ( ctrl.classList.contains( 'collapsed' ) ) {
				// Expand
				ctrl.innerHTML = ctrl.innerHTML.replace( /More/g, 'Less' );
				container
				.querySelectorAll( expandedSelector )
				.forEach( function( el ) {
					el.classList.remove( 'd-none' );
				} );
				container
				.querySelectorAll( collapsedSelector )
				.forEach( function( el ) {
					el.classList.add( 'd-none' );
				} );
				ctrl.classList.remove( 'collapsed' );
			} else {
				// Collapse
				ctrl.innerHTML = ctrl.innerHTML.replace( /Less/g, 'More' );
				container
				.querySelectorAll( expandedSelector )
				.forEach( function( el ) {
					el.classList.add( 'd-none' );
				} );
				container
				.querySelectorAll( collapsedSelector )
				.forEach( function( el ) {
					el.classList.remove( 'd-none' );
				} );
				ctrl.classList.add( 'collapsed' );
			}
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
